/**
 * Calendar date key (local timezone) for comparing workshop dates.
 * @param {Date} d
 */
export function localDateKey(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Workshop is past after its scheduled calendar day (local time).
 * @param {string} workshopDate — YYYY-MM-DD
 * @param {Date} [now]
 */
export function isBulandiWorkshopPast(workshopDate, now = new Date()) {
  const date = String(workshopDate || "").trim();
  if (!date) return false;
  return localDateKey(now) > date;
}

/**
 * @param {Array<{ workshopDate: string } & Record<string, unknown>>} workshops
 * @param {Date} [now]
 */
export function partitionBulandiWorkshops(workshops, now = new Date()) {
  const upcoming = [];
  const past = [];
  for (const ws of workshops) {
    if (isBulandiWorkshopPast(ws.workshopDate, now)) {
      past.push(ws);
    } else {
      upcoming.push(ws);
    }
  }
  const byDate = (a, b) =>
    String(a.workshopDate).localeCompare(String(b.workshopDate));
  upcoming.sort(byDate);
  past.sort((a, b) => byDate(b, a));
  return { upcoming, past };
}
